<template>
  <div class="alert alert-warning text-dark text-center">
    <i class="fa fa-exclamation-triangle"/>
    *Dropships are subject to each vendors prepaid freight and minimum order policies.
  </div>
</template>